<template>

  <div class="audio-panel" id="AUDIOPANEL-SWF">
    
    <!-- tab切换 -->
    <div class="audio-tabs">
      <div  v-for="item, index in tabs" 
            :class="{'active':item.active}" 
            @click="handleTabsChange(index, tabs)">
        {{item.name}}
      </div>
    </div>
    
    <!-- 配音组件 -->
    <div v-show="tabs_status == 0">
      <record></record>
    </div>

    <!-- 背景音组件 -->
    <div v-show="tabs_status == 1">
      <bgm></bgm>
    </div>
  </div>  
</template>

<script>

  // Psocket 组件
  import Psocket from '@/components/Flash/PSocket'

  // 通讯协议
  import Protocol from '@/common/scripts/protocol.js'

  // 配音
  import Record from '@/components/Record/Record'

  // 背景音
  import Bgm from '@/components/Bgm/Bgm'

  export default {
    name: 'AUDIOPANEL',
    components: {
      Record,
      Bgm,
    },
    data () {
      return {

        // tab数据
        tabs: [
          // { name: '配音', active: true },
          { name: '背景音', active: false }
        ],

        //tab切换状态值 
        tabs_status: '1',

        // 场景加载完成
        init: '',

        // -------------------------------------------------- [ FLASH ] --------------------------------------------------
        
        flashvars: {
          module: AUDIOPANEL_NAME
        },

        attributes: {
          id: AUDIOPANEL_NAME + '-PSOCKET'
        },
      }
    },
    methods: {

      // tab 切换-----配音/背景音
      handleTabsChange(index, data) {

        this.tabs_status = index

        this.changeTab(index, data)

      },

      // 切换公共方法
      changeTab(index, data) {

        for (let i = 0; i < data.length; i++) {

          data[i].active = false

        }

        data[index].active = true
        
      },
    },
    mounted () {

      let platform = this.$route.query.platform

      let _this = this

      // AUDIOPANEL
      // 模块初始化
      Protocol.onSocketInit(platform, AUDIOPANEL_NAME, AUDIOPANEL)
      // 模块与服务器建立链接
      Protocol.onSocketConnect(platform,AUDIOPANEL_NAME)
      // 模块与服务器建立链接
      Protocol.onSocketRegister(platform, AUDIOPANEL_NAME, AUDIOPANEL)
      // 接收消息
      Protocol.receiver(platform, AUDIOPANEL_NAME)
      
      window[AUDIOPANEL_NAME].message = function (senderId, packageId, sessionId, messageId, protoBytes) {
 
      }

    }
  }
</script>

<style lang="stylus" scoped>
  .audio-panel
    background: #505050//#e8e8e8
    position: absolute
    top: 0
    right: 0
    bottom: 0
    left: 0
    .audio-tabs
      display: flex
      div
        background: #3d3d3d//#f0f0f0
        color: #e2e2e2//#333
        flex: 1
        line-height: 25px
        border: 1px solid #3d3d3d//#e9e9e9
        text-align: center
        cursor: pointer
        box-sizing: border-box
      .active
        color: #e2e2e2//#2f2f2f
        background: #505050//#e8e8e8
</style>


// WEBPACK FOOTER //
// AudioPanel.vue?d78b0e18